export const API_URL = "https://api.bexcod.com";